import { Dialog, Tag } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import { UnionAlloyEvaluationType } from "./AlloyEvaluationSummary";
import { getEvaluationOutcomeHeader } from "./utils";

export function AlloyEvaluationModal({
  evaluation,
  isModalOpen,
  setIsModalOpen,
}: {
  evaluation: UnionAlloyEvaluationType;
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
}) {
  return (
    <Dialog
      isOpen={isModalOpen}
      onUserDismiss={() => setIsModalOpen(false)}
      title={getEvaluationOutcomeHeader(evaluation)}
    >
      <div className="margin--y--m">
        {evaluation.tags.map((tag) => {
          return (
            <div className="margin--y--s" key={tag}>
              <Tag label={Filters.humanize(tag)} />
            </div>
          );
        })}
      </div>
      <p className="fontSize--s">
        <a
          href={`https://app.alloy.co/entities/${evaluation.entity_token}/evaluations/${evaluation.evaluation_token}/`}
          target="_blank"
        >
          View in Alloy
        </a>
      </p>
    </Dialog>
  );
}
